module.exports = __webpack_public_path__ + "static/media/532254b38c3704f175fd49fcc5f2049811476e78_cropped.0f4beff5.jpg";